export default __webpack_public_path__ + "static/values-create-tomorrow-33186ab05fd84f6dfb14a0e02ffff2e0.svg";